<template>
  <div>
    <w-text-field
      v-if="!readonly"
      ref="textField"
      v-bind="$props"
      :value="formattedTimeAmount"
      :error-messages="errorMessages"
      @change="formattedTimeAmount = $event"
    />
    <w-read-only-text-field
      v-else
      v-bind="$props"
      :value="formattedTimeAmount"
    />
  </div>
</template>

<script>
// components
import { VTextField } from 'vuetify/lib';

// mixins
import isRequired from '@/mixins/component/is-required-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';

// helpers
import temporalAmountFormatService from '../../../services/temporal-amount-format-service.js';

/**
 * @component WorkTemporalAmountField
 * @description Input field for time durations in `H:MM` format (hours:minutes).
 * Converts internally between minutes (numeric) and formatted display string.
 * All Vuetify `VTextField` props are inherited.
 *
 * @prop {Boolean} [inlineReadOnly=false] - Inline read-only display.
 *
 * @emits {Number} input - Emitted when the value changes. Passes the duration in minutes.
 */
export default {
  name: 'WorkTemporalAmountField',
  mixins: [isRequired, pendingAble],
  props: {
    inlineReadOnly: { type: Boolean, default: false },
    ...VTextField.options.props
  },
  data() {
    return {
      lazyValue: this.value
    };
  },
  computed: {
    formattedTimeAmount: {
      get() {
        return temporalAmountFormatService.formatMinutesToWorkingHours(
          this.internalValue ? this.internalValue : null
        );
      },
      set(newValue) {
        var inputValue =
          this.internalValue == undefined && newValue == undefined
            ? undefined
            : temporalAmountFormatService.mapTimeAmountToMinutes(newValue);

        this.internalValue = inputValue != undefined ? inputValue : null;
        this.$refs.textField.lazyValue = this.formattedTimeAmount;
      }
    },
    internalValue: {
      get() {
        return this.lazyValue;
      },
      set(val) {
        if (val != this.lazyValue) {
          this.lazyValue = val != undefined ? val : 0;
          this.$emit('input', val);
        }
      }
    }
  },
  watch: {
    value(val) {
      this.lazyValue = val;
    }
  },
  methods: {
    focus() {
      this.$refs.textField.focus();
    }
  }
};
</script>
